import { useMemo } from 'react';

import type { ComponentClassNames } from './classNames';
import { getFocusStyle } from './styles/focusOutlines';
import { mergeStyleSets } from './styling';
import type { ClickableStyleProps } from './useLinkStyles';
import { useLinkStyles } from './useLinkStyles';

type GetLinkClassNames = (props: ClickableStyleProps) => ComponentClassNames<'link'>;
export const useLinkClassNames: GetLinkClassNames = (props) => {
  const linkStyles = useLinkStyles({
    activeColor: props.activeColor,
    alwaysUnderline: props.alwaysUnderline,
    className: props.className,
    color: props.color,
    colorOverride: props.colorOverride,
    disabled: props.disabled,
    display: props.display,
    focusOutline: props.focusOutline,
    unstyled: props.unstyled,
  });

  return useMemo(
    () =>
      mergeStyleSets({
        link: [linkStyles, getFocusStyle({ focusOutline: props.focusOutline }), props.className],
      }),
    [linkStyles, props.className, props.focusOutline]
  );
};
